export default __webpack_public_path__ + "static/media/object--support--utility-pole.71ce4ba5.png";